import { Action } from 'redux';
import { UnityEngineAppConfig } from '../config';
import { WorkoutRuntimeOptions } from '../options';
import { UnityEngineExerciseSettings } from '../settings';

export const UNITY_APP_READY = '@@unity/UNITY_APP_READY';
export type UNITY_APP_READY = typeof UNITY_APP_READY;
export interface IUnityAppReadyAction extends Action<UNITY_APP_READY> {
  type: UNITY_APP_READY;
}

export const UNITY_ENGINE_READY = '@@unity/UNITY_ENGINE_READY';
export type UNITY_ENGINE_READY = typeof UNITY_ENGINE_READY;
export interface IUnityEngineReadyAction extends Action<UNITY_ENGINE_READY> {
  type: UNITY_ENGINE_READY;
}

export const UNITY_EXERCISE_READY = '@@unity/UNITY_EXERCISE_READY';
export type UNITY_EXERCISE_READY = typeof UNITY_EXERCISE_READY;
export interface IUnityExerciseReadyAction extends Action<UNITY_EXERCISE_READY> {
  type: UNITY_EXERCISE_READY;
}

export const UNITY_EXERCISE_COMPLETE = '@@unity/UNITY_EXERCISE_COMPLETE';
export type UNITY_EXERCISE_COMPLETE = typeof UNITY_EXERCISE_COMPLETE;
export interface IUnityExerciseCompleteAction extends Action<UNITY_EXERCISE_COMPLETE> {
  type: UNITY_EXERCISE_COMPLETE;
  payload: string;
}

export const UNITY_EXERCISE_FAILED = '@@unity/UNITY_EXERCISE_FAILED';
export type UNITY_EXERCISE_FAILED = typeof UNITY_EXERCISE_FAILED;
export interface IUnityExerciseFailedAction extends Action<UNITY_EXERCISE_FAILED> {
  type: UNITY_EXERCISE_FAILED;
  payload: string;
}

export const UNITY_PROGRESS_UPDATE = '@@unity/UNITY_PROGRESS_UPDATE';
export type UNITY_PROGRESS_UPDATE = typeof UNITY_PROGRESS_UPDATE;
export interface IUnityProgressUpdateAction extends Action<UNITY_PROGRESS_UPDATE> {
  type: UNITY_PROGRESS_UPDATE;
  payload: number;
}

export const UNITY_INIT = '@@unity/UNITY_INIT';
export type UNITY_INIT = typeof UNITY_INIT;
export interface IUnityInitAction extends Action<UNITY_INIT> {
  type: UNITY_INIT;
  payload: {
    basePath: string;
    canvasId: string;
    fullscreenClass?: string;
    dataUrl?: string;
    codeUrl?: string;
    frameworkUrl?: string;
  };
}

export const UNITY_LOADER_START = '@@unity/UNITY_LOADER_START';
export type UNITY_LOADER_START = typeof UNITY_LOADER_START;
export interface IUnityLoaderStartAction extends Action<UNITY_LOADER_START> {
  type: UNITY_LOADER_START;
}

export const UNITY_APP_INIT = '@@unity/UNITY_APP_INIT';
export type UNITY_APP_INIT = typeof UNITY_APP_INIT;
export interface IUnityAppInitAction extends Action<UNITY_APP_INIT> {
  type: UNITY_APP_INIT;
  payload: UnityEngineAppConfig;
}

export const UNITY_EXERCISE_INIT = '@@unity/UNITY_EXERCISE_INIT';
export type UNITY_EXERCISE_INIT = typeof UNITY_EXERCISE_INIT;
export interface IUnityExerciseInitAction extends Action<UNITY_EXERCISE_INIT> {
  type: UNITY_EXERCISE_INIT;
  payload: UnityEngineExerciseSettings;
}

export const UNITY_EXERCISE_START = '@@unity/UNITY_EXERCISE_START';
export type UNITY_EXERCISE_START = typeof UNITY_EXERCISE_START;
export interface IUnityExerciseStartAction extends Action<UNITY_EXERCISE_START> {
  type: UNITY_EXERCISE_START;
  payload: WorkoutRuntimeOptions;
}

export const UNITY_EXERCISE_RUNNING = '@@unity/UNITY_EXERCISE_RUNNING';
export type UNITY_EXERCISE_RUNNING = typeof UNITY_EXERCISE_RUNNING;
export interface IUnityExerciseRunningAction extends Action<UNITY_EXERCISE_RUNNING> {
  type: UNITY_EXERCISE_RUNNING;
}

export const UNITY_EXERCISE_REMOVE = '@@unity/UNITY_EXERCISE_REMOVE';
export type UNITY_EXERCISE_REMOVE = typeof UNITY_EXERCISE_REMOVE;
export interface IUnityExerciseRemoveAction extends Action<UNITY_EXERCISE_REMOVE> {
  type: UNITY_EXERCISE_REMOVE;
}

export const UNITY_STOP = '@@unity/UNITY_STOP';
export type UNITY_STOP = typeof UNITY_STOP;
export interface IUnityStopAction extends Action<UNITY_STOP> {
  type: UNITY_STOP;
}

export const UNITY_LOG = '@@unity/UNITY_LOG';
export type UNITY_LOG = typeof UNITY_LOG;
export interface IUnityLogAction extends Action<UNITY_LOG> {
  type: UNITY_LOG;
  payload: string;
}

export const UNITY_ERROR = '@@unity/UNITY_ERROR';
export type UNITY_ERROR = typeof UNITY_ERROR;
export interface IUnityErrorAction extends Action<UNITY_ERROR> {
  type: UNITY_ERROR;
  payload: string;
}

export const UNITY_ALERT = '@@unity/UNITY_ALERT';
export type UNITY_ALERT = typeof UNITY_ALERT;
export interface IUnityAlertAction extends Action<UNITY_ALERT> {
  type: UNITY_ALERT;
  payload: string;
}

export const UNITY_LOADING_START = '@@unity/UNITY_LOADING_START';
export type UNITY_LOADING_START = typeof UNITY_LOADING_START;
export interface IUnityLoadingStartAction extends Action<UNITY_LOADING_START> {
  type: UNITY_LOADING_START;
}

export const UNITY_LOADING_END = '@@unity/UNITY_LOADING_END';
export type UNITY_LOADING_END = typeof UNITY_LOADING_END;
export interface IUnityLoadingEndAction extends Action<UNITY_LOADING_END> {
  type: UNITY_LOADING_END;
}

/**
 * @deprecated use IUnityStatsUpdateAction instead
 */
export const UNITY_GAMEPLAY_SOUND_SETTINGS_UPDATED = '@@unity/UNITY_GAMEPLAY_SOUND_SETTINGS_UPDATED';
export type UNITY_GAMEPLAY_SOUND_SETTINGS_UPDATED = typeof UNITY_GAMEPLAY_SOUND_SETTINGS_UPDATED;
export interface IUnityGameplaySoundSettingsUpdatedAction extends Action<UNITY_GAMEPLAY_SOUND_SETTINGS_UPDATED> {
  type: UNITY_GAMEPLAY_SOUND_SETTINGS_UPDATED;
  payload: number;
}

/**
 * @deprecated use IUnityStatsUpdateAction instead
 */
export const UNITY_GAMEPLAY_BACKGROUND_SETTINGS_UPDATED = '@@unity/UNITY_GAMEPLAY_BACKGROUND_SETTINGS_UPDATED';
export type UNITY_GAMEPLAY_BACKGROUND_SETTINGS_UPDATED = typeof UNITY_GAMEPLAY_BACKGROUND_SETTINGS_UPDATED;
export interface IUnityGameplayBackgroundSettingsUpdatedAction
  extends Action<UNITY_GAMEPLAY_BACKGROUND_SETTINGS_UPDATED> {
  type: UNITY_GAMEPLAY_BACKGROUND_SETTINGS_UPDATED;
  payload: number;
}

/**
 * @deprecated use IUnityStatsUpdateAction instead
 */
export const UNITY_GAMEPLAY_FULLSCREEN_SETTINGS_UPDATED = '@@unity/UNITY_GAMEPLAY_FULLSCREEN_SETTINGS_UPDATED';
export type UNITY_GAMEPLAY_FULLSCREEN_SETTINGS_UPDATED = typeof UNITY_GAMEPLAY_FULLSCREEN_SETTINGS_UPDATED;
export interface IUnityGameplayFullscreenSettingsUpdatedAction
  extends Action<UNITY_GAMEPLAY_FULLSCREEN_SETTINGS_UPDATED> {
  type: UNITY_GAMEPLAY_FULLSCREEN_SETTINGS_UPDATED;
  payload: number;
}

export const UNITY_TRACK_EVENT = '@@unity/UNITY_TRACK_EVENT';
export type UNITY_TRACK_EVENT = typeof UNITY_TRACK_EVENT;
export interface IUnityTrackEventAction extends Action<UNITY_TRACK_EVENT> {
  type: UNITY_TRACK_EVENT;
  payload: string;
}

export const UNITY_STATS_UPDATE = '@@unity/UNITY_STATS_UPDATE';
export type UNITY_STATS_UPDATE = typeof UNITY_STATS_UPDATE;
export interface IUnityStatsUpdateAction extends Action<UNITY_STATS_UPDATE> {
  type: UNITY_STATS_UPDATE;
  statId: string;
  payload: string;
}

export type UnityAction =
  | IUnityAppReadyAction
  | IUnityEngineReadyAction
  | IUnityExerciseReadyAction
  | IUnityExerciseCompleteAction
  | IUnityExerciseFailedAction
  | IUnityProgressUpdateAction
  | IUnityInitAction
  | IUnityLoaderStartAction
  | IUnityAppInitAction
  | IUnityExerciseInitAction
  | IUnityExerciseStartAction
  | IUnityExerciseRunningAction
  | IUnityStopAction
  | IUnityLogAction
  | IUnityErrorAction
  | IUnityAlertAction
  | IUnityLoadingStartAction
  | IUnityLoadingEndAction
  | IUnityGameplaySoundSettingsUpdatedAction
  | IUnityGameplayBackgroundSettingsUpdatedAction
  | IUnityGameplayFullscreenSettingsUpdatedAction
  | IUnityTrackEventAction
  | IUnityStatsUpdateAction;
